import Box from "@mui/material/Box";
import "./TabBoxContainer.scss"
export default function TabBoxContainer({children}) {
    return (
        <Box
            sx={{borderBottom: 1, borderColor: 'divider'}}
            className={"tabBoxContainer"}
        >
            {children}
        </Box>
    )
}